import { COMMON_MSG } from './error';


// error handler
export const ERROR_MESSAGE = {
  get packageList() {
    const errCodeArr = window.dxllData?.unsupportErrCode?.split('@');
    return errCodeArr?.[0] ? mapGame(errCodeArr[0]) : {};
  },

  orderPackage: {
    20301: '订购信息错误，请重试',
    20302: '当前手机号已经存在生效的流量包，请更换手机号或账号再来',
    20303: '手机号的运营商与该商品配置的运营商不一致',
    20304: '当前手机号或账号已存在生效的流量包，请更换手机号或账号再来',
    20305: '当前手机号或账号已存在生效的流量包，请更换手机号或账号再来',
  },

  submitOrder: {
    20506: '您的账号和已提交订单的账号不一致，无法订购，请更换账号再来',
    20901: COMMON_MSG,
  },
  activateOrder: {
    20201: '当前openId已存在有效订单',
    20202: '当前openId存在流程中订单',
    20203: '当前手机号存在流程中订单',
    20204: '查不到订单',
    20205: '验证码错误',
  },

  applyActiveSmsCode: {
    20201: '当前openId已存在有效订单',
    20202: '当前openId存在流程中订单',
    20203: '当前手机号存在流程中订单',
    20204: '查不到订单',
  },

  unsubscribeSmsCode: {
    20301: '非法订购PID',
    20302: '该openId或者手机号已订购',
  },
  orderSmsCode: {
    4: '获取验证码频繁，请一分钟后再试',
    20401: '不支持的手机号段，只支持电信',
    20402: '订购信息错误，请稍后重试', // `非法pId，不支持订购`,
    20403: '订购信息错误，请稍后重试', // `非法游戏编码，请运营检查游戏配置`,
    20901: '获取验证码频繁，请一分钟后再试', // `供应商接口调用错误`,
    20302: '当前手机号或账号已存在生效的流量包，请更换手机号或账号再来',
    20304: '当前手机号或账号已存在生效的流量包，请更换手机号或账号再来',
    20306: '您当前手机号暂不支持订购，如需了解具体原因，可致电号码归属运营商',
    201022: '您当前手机号暂不支持订购，如需了解具体原因，可致电号码归属运营商。',
    201028: '您当前手机号暂不支持订购，如需了解具体原因，可致电号码归属运营商。',
  },

  queryUserOrderStatus: {},

  queryOrderStatusByMobile: {},
};

// 不支持订购异常流错误码
export const getPkgListUnsupportError = function (key) {
  const errCodeArr = window.dxllData?.unsupportErrCode?.split('@');
  let pkglistUnsupportError = {};
  if (errCodeArr) {
    pkglistUnsupportError = mapGame(errCodeArr[1]);
  }
  pkglistUnsupportError['0'] = '';
  return pkglistUnsupportError[key];
};

// 移动
export const MOBILE_TYPE = 1;
// 联通
export const UNION_TYPE = 2;
// 电信
export const TELECOM_TYPE = 3;

// 登录类型
export const LOGIN_TYPES = {
  // 端内
  MSDK: 1,
  // 端外有登录
  NON_MSDK_LOGIN: 2,
  // 端外无登录
  NON_MSDK_NO_LOGIN: 3,
};

export const OPERATOR_TYPE2ISP = {
  1: 'yd',
  2: 'lt',
  3: 'dx',
};

// AB 实验 KEY 信息
export const AB_KEYS = {
  // 暂无进行中实验
};

export const envMap = {
  wx: '微信用户',
  qq: 'QQ用户',
};

export const FINISH_ORDER_KEY = 'finishOrder';

export const AUTO_SCROLL_AWARD = 'auto-scroll-award';
export const NON_MSDK_KEYS = ['loginType', 'token', 'nickName', 'openid']; // 端外登录态key

export const ACCOUNT_TYPE = {
  WX: 1,
  QQ: 2,
};

// e.g .flow.qq.com
export const COOKIE_DOMAIN = location.hostname.match(/\.(.+)$/)?.[0];

export const ACTIVITY_PAGE = 'activityUrl';

export const PACKAGE_TYPE = {
  AMS: 1, // ams 礼包
  GOODS: 2, // 实物
  NOTHING: 3, // 谢谢参与
  GAME_CURRENCY: 6, // 游戏币
};

// 定向礼包是否已被领取
export const GIFT_STATUS = {
  RECEIVED: 1, // 已领取
};

export const ORDER_CACHE_KEY = 'order_cache_';

export const ORDER_ID_KEY = 'order_id_';

export const LINK_ERROR_REPORT = 'LINK_ERROR_REPORT';

export const VISITED_PAGE_KEY = 'flow_page_visit';

export const LIMITED_ACTIVITY_TYPE = {
  USER_ORDER_TIME_NEW: 'newUserOnly', // 新用户订购时间计算续订时长
  USER_ORDER_TIME_OLD: 'supportOldUser', // 老用户订购时间计算续订时长
  LATEST_TIME: 'latestTime', // (新逻辑)最晚(活动时间/订购时间)计算续订时长
};

export const LIMITED_ACTIVITY_TYPE_TEXT_MAP = {
  [LIMITED_ACTIVITY_TYPE.USER_ORDER_TIME_NEW]: '新用户订购时间计算续订时长',
  [LIMITED_ACTIVITY_TYPE.USER_ORDER_TIME_OLD]: '老用户订购时间计算续订时长',
  [LIMITED_ACTIVITY_TYPE.LATEST_TIME]: '阶段留存：最晚(活动时间/订购时间)计算续订时长',
};

// atta 上报的 platform 类型，iOS 1, android 2, pc 3
export const ATTA_REPORT_PLATFORM_PC = 3;
